import React, { useEffect } from 'react'
import {
  TheContent,
  TheFooter,
  TheHeader
} from './index'
import { useSelector, useDispatch } from 'react-redux'
import Interceptor from "../helpers/interceptor";
import './container.css';
import '../css/bootstrap.min.css';
import '../css/animations.css';
import '../css/style.css?v=3';
import '../css/custom.css?v=5';
import '../css/responsive.css';
import '../css/white-theme.css';
import '../css/English.css?v=2';
import '../js/script';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { userActions } from '../actions';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
}));


const TheLayout = ({changeLangClass}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const loginuser = user ? user.user : null;

  useEffect(() => {

  }, [])

  return (
    <React.Fragment>
      <CssBaseline />
      <Interceptor />
      <TheHeader changeLangClass={changeLangClass}/>
      <TheContent />
      <TheFooter />
    </React.Fragment>
  )
}

export default TheLayout
